import { DEAL_CLOSED_STATUSES, RECURRING_BILLING, TODAY } from '../../constants';
import type { Deal, DealLine } from '../../types/domain';
import { contractMonthsInYear, contractTotalMonths } from '../dates';
import { estimatedOpenMonths, soldOpenMonths } from './contractLength';
import { activeLines } from './lines';
import { dealDecisionYear } from './soldRevenue';

const THIS_YEAR = String(TODAY.getFullYear());

// Année de rattachement d'une affaire (filtres, dashboard) : suspendue ou perdue → année de
// clôture (date_decision, à défaut année de création) ; gagnée → année de signature ; en vente →
// année en cours.
export function dealAttachmentYear(a: Deal): string {
  if (DEAL_CLOSED_STATUSES.includes(a.statut as string))
    return (a.date_decision || a.created_at || '').slice(0, 4) || THIS_YEAR;
  return dealDecisionYear(a) || THIS_YEAR;
}

// Années couvertes par une ligne récurrente datée (mois du contrat rattachés à l'année où ils
// commencent), sinon null.
function recurringLineYears(l: DealLine): string[] | null {
  if (!RECURRING_BILLING.includes(l.facturation as string) || !l.date_debut_prevue) return null;
  const y0 = Number(l.date_debut_prevue.slice(0, 4));
  const open = Math.max(soldOpenMonths(l), estimatedOpenMonths(l));
  const months = contractTotalMonths(l.date_debut_prevue, l.date_fin_prevue) || open;
  const years: string[] = [];
  for (let y = y0; y <= y0 + Math.ceil(months / 12); y++)
    if (contractMonthsInYear(l.date_debut_prevue, l.date_fin_prevue, y, open) > 0)
      years.push(String(y));
  return years;
}

// Années dans lesquelles une affaire compte (sélecteur d'années, filtre du dashboard, fiche
// contact) : chaque année couverte par ses lignes récurrentes datées, et son année de
// rattachement pour les autres lignes ou si elle n'a pas de ligne.
export function dealYearsOf(a: Deal): string[] {
  const years = new Set<string>();
  const lines = activeLines(a);
  if (!lines.length) years.add(dealAttachmentYear(a));
  for (const l of lines) {
    const recurring = recurringLineYears(l);
    if (recurring) recurring.forEach((y) => years.add(y));
    else years.add(dealAttachmentYear(a));
  }
  return [...years];
}
